import { FONTS, fontSize } from "../../../../../../styles/fonts";
import { css, SerializedStyles } from "@emotion/react";
import { CSS_COLORS } from "../../../../../../styles/styles-css-variables";
import React from "react";

export const InputPlaceholder: React.FC<{ placeholder: string; optional?: boolean }> = props => {
  return (
    <span className={"placeholder"} css={textFieldPlaceholderStyles}>
      {props.placeholder}
      {!props.optional ? "*" : ""}
    </span>
  );
};

export const textFieldPlaceholderStyles = [
  fontSize.x25,
  FONTS.SwarovskiFutura300,
  css`
    pointer-events: none;
    z-index: 0;

    color: ${CSS_COLORS.Grey3};

    position: absolute;
    left: 50px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  `,
];

export const InputPlaceholder2: React.FC<{
  placeholder: string;
  required: boolean;
  attachStyles: SerializedStyles;
}> = props => {
  return (
    <span className={"placeholder"} css={[props.attachStyles, ...textFieldPlaceholderStyles2]}>
      {props.placeholder}
      {props.required ? "*" : ""}
    </span>
  );
};

export const textFieldPlaceholderStyles2 = [
  fontSize.x2,
  FONTS.SwarovskiFutura300,
  css`
    pointer-events: none;
    z-index: 0;

    background-color: var(--bg-color);
    color: var(--text-placeholder-color);

    padding: 2px 4px 0;

    border-radius: 8px;

    display: flex;
    align-items: center;
  `,
];
